import React from "react";
import learningportal from "../../assets/image/learningportal.svg";
import Controls from "../controls/control";
import LogoutSVG from "../svg/LogoutSVG";
import StudentNavLink from "./StudentNavLink";
import AdminNavLink from "./AdminNavLink";
import { useDispatch } from "react-redux";
import { userLogOut } from "../../features/Auth/authSlice";

export default function Navbar({ isAdmin, user }) {
  const dispatch = useDispatch();
  const handleLogOut = () => {
    localStorage.clear();
    dispatch(userLogOut());
  };
  return (
    <nav className="shadow-md">
      <div className="max-w-7xl px-5 lg:px-0 mx-auto flex justify-between py-3">
        <img className="h-10" src={learningportal} alt="learningportal" />
        <div className="flex items-center gap-3">
          {isAdmin ? <AdminNavLink /> : <StudentNavLink />}
          <h2 className="font-bold">{user}</h2>
          <Controls.Button
            text={"Logout"}
            className={
              isAdmin
                ? "flex gap-2 items-center px-4 py-1 rounded-full text-sm transition-all bg-red-600 hover:bg-red-700 font-medium"
                : "flex gap-2 border border-cyan items-center px-4 py-1 rounded-full text-sm transition-all hover:bg-cyan"
            }
            startIcon={<LogoutSVG />}
            onClick={handleLogOut}
          />
        </div>
      </div>
    </nav>
  );
}
